import React from 'react';

const Header = ({title, content, secondary}) => {
    return ( 
        <div className='grid grid-cols-2 items-center mb-4 mt-2'>
            {secondary ?
            <div className='text-2xl text-danger'>{title}</div>
            :
            <div className='text-3xl'>{title}</div>
            }
            <span className='justify-self-end'>
            {content}
            </span>
        </div>
 );
}
 
export default Header;